



export const formatInputCurrencyValues = ({ value, saveAction }) => {
    const inputValue = value.replace(/\D/g, ''); // Remove caracteres não numéricos
    const numericValue = parseInt(inputValue, 10);

    if (isNaN(numericValue)) {
        saveAction('');
      return;
    }

    const formattedValue = (numericValue / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    saveAction(formattedValue);
};